const ALLOWED_CANCELLATION_DOCUMENT_TYPES =
  /\.(pdf|docx?|xlsx?|csv|txt|png|jpe?g)$/i;
const MAX_CANCELLATION_DOCUMENT_SIZE_MB = 25;

export function validateCancellationFiles(
  files: File[],
  onError: (translationKey: string) => void
): File[] {
  return files.filter((file) => {
    if (!ALLOWED_CANCELLATION_DOCUMENT_TYPES.test(file.name)) {
      onError("errors.unsupportedFileType");
      return false;
    }

    if (file.size / 1_048_576 > MAX_CANCELLATION_DOCUMENT_SIZE_MB) {
      onError("errors.fileTooLarge");
      return false;
    }

    return true;
  });
}
